// Course / scene font, as the canvas hands it down. A text box follows the
// scene's inherited font-family, but components that set a font of their own
// (smart elements' --font-heading/--font-body, quiz chrome) would beat it. The
// scene therefore also exposes the font as a CSS variable, and those components
// read it with their own font as the fallback: no course font chosen → they
// look exactly as before. Same in the editor and the Visor.

export const COURSE_FONT_VAR = "--aidea-course-font";

/** Inline style for a scene container whose course / scene font is `font`. */
export const sceneFontStyle = (font) => (font ? { fontFamily: font, [COURSE_FONT_VAR]: font } : {});

/** A font-family value that follows the course font, else `fallback`. */
export const withCourseFont = (fallback) => `var(${COURSE_FONT_VAR}, ${fallback})`;
